<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p3"><span><a href="#/Contents#rp3">LOW-SALT CHICKEN STOCK</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="normal"><span><i>Save chicken bones in a plastic bag in the freezer for making chicken stock.</i></span></p>
<p class="make"><span>Makes about 2 quarts</span></p>
<p class="hang"><span>2½ quarts water</span></p>
<p class="hang"><span>1 pound skinless chicken breast</span></p>
<p class="hang"><span>2 each: thickly sliced medium onions, ribs celery, carrots</span></p>
<p class="hang"><span>1 large red potato, quartered</span></p>
<p class="hang"><span>½ cup packed parsley sprigs</span></p>
<p class="hang"><span>Salt and pepper, to taste</span></p>
<p class="normalt"><span><b>1.</b> Heat all ingredients, except salt and pepper, to boiling in large saucepan; reduce heat and simmer, covered, 1½ hours, skimming any foam from surface. Strain stock through double layer of cheesecloth, discarding chicken, vegetables, and parsley; season to taste with salt and pepper. Refrigerate until chilled; remove congealed fat from surface of stock.</span></p>
<p class="per"><span>Per Cup:</span></p>
<p class="per1"><span>Calories: 8</span></p>
<p class="per1"><span>% calories from fat: 0</span></p>
<p class="per1"><span>Protein (g): 1.6</span></p>
<p class="per1"><span>Carbohydrate (g): 1.2</span></p>
<p class="per1"><span>Fat (g): 0</span></p>
<p class="per1"><span>Saturated fat (g): 0</span></p>
<p class="per1"><span>Cholesterol (mg): 0</span></p>
<p class="per1"><span>Sodium (mg): 4</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 0.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter013.vue?7eed6c2c